export enum CaptureType {
  Selfie = 'Selfie',
  IdFront = 'IdFront',
}
